import React from "react";
import GenericCrudPage from "../common/GenericCrudPage";
import {
  getQuestionDifficulties,
  createQuestionDifficulty,
  updateQuestionDifficulty,
  deleteQuestionDifficulty,
} from "../../../services/QuestionDifficultyService";
import { useTranslation } from "react-i18next";

const QuestionDifficulties = () => {
  const { t } = useTranslation();
  return (
  <GenericCrudPage
      permissionModule="QUESTION_DIFFICULTY"
    title={t("pages.questionDifficulties.title")}
    breadcrumbLabel={t("pages.questionDifficulties.breadcrumb")}
    addLabel={t("pages.questionDifficulties.addLabel")}
    searchPlaceholder={t("common.ui.rechercherCodeNom")}
    defaultSort={{ by: "level_order", dir: "asc" }}
    api={{
      list: getQuestionDifficulties,
      create: createQuestionDifficulty,
      update: updateQuestionDifficulty,
      remove: deleteQuestionDifficulty,
    }}
    columns={[
      { key: "level_order", label: t("common.fields.order"), sortable: true },
      { key: "code", label: t("common.fields.code"), sortable: true },
      { key: "name", label: t("common.fields.name"), sortable: true },
      { key: "score_weight", label: t("pages.questionDifficulties.scoreWeight") },
    ]}
    fields={[
      { key: "code", label: t("common.fields.code"), type: "text", required: true, placeholder: "EASY", maxLength: 20 },
      { key: "name", label: t("common.fields.name"), type: "text", required: true, placeholder: t("pages.questionDifficulties.facile"), maxLength: 50 },
      { key: "level_order", label: t("common.fields.order"), type: "number", required: true, placeholder: "1" },
      { key: "score_weight", label: t("pages.questionDifficulties.scoreWeightField"), type: "number", placeholder: "1" },
      { key: "is_active", label: t("common.crud.statusActive"), type: "checkbox" },
    ]}
    buildPayload={(formData) => ({
      code: formData.code.trim(),
      name: formData.name.trim(),
      level_order: Number(formData.level_order) || 1,
      score_weight: formData.score_weight !== "" ? Number(formData.score_weight) : 1,
      is_active: formData.is_active !== undefined ? !!formData.is_active : true,
    })}
    getItemLabel={(item) => item.name}
  />
);
};

export default QuestionDifficulties;
